<template>
  <div>
    <b-row class="text-primary">
      <b-col>
        <h4 class="text-success text-center" v-if="tituloEditar">Editar Procedimiento</h4>
        <b-card>
          <b-form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-2">
                <span> Código</span>
                <b-form-input id="codigo" v-model="procedimiento.codigo" type="text" required />
              </div>
              <div class="col-10">
                <span> Descripcion del procedimiento</span>
                <b-form-textarea id="descripcion" v-model="procedimiento.descripcion" rows="3" type="text" required />
              </div>
            </div>
            <hr />
            <span>Precios:</span>
            <div class="row mt-1">
              <div class="col">
                <span>Iess</span>
                <b-form-input
                  id="precIess1"
                  @keypress="soloNumeros"
                  v-model="procedimiento.precioJson.iess_n1"
                  type="float"
                  required
                />
              </div>
              <div class="col">
                <span>Issfa Nivel 1</span>
                <b-form-input
                  id="precIssfa1"
                  @keypress="soloNumeros"
                  v-model="procedimiento.precioJson.issfa_n1"
                  type="float"
                  required
                />
              </div>
              <div class="col">
                <span>Issfa Nivel 2</span>
                <b-form-input
                  id="precIssfa2"
                  @keypress="soloNumeros"
                  v-model="procedimiento.precioJson.issfa_n2"
                  type="float"
                  required
                />
              </div>
              <div class="col">
                <span>Precio Isspol</span>
                <b-form-input
                  id="precIsspol1"
                  @keypress="soloNumeros"
                  v-model="procedimiento.precioJson.isspol_n1"
                  type="float"
                  required
                />
              </div>
              <div class="col">
                <span>Precio Particular</span>
                <b-form-input
                  id="precparticular"
                  @keypress="soloNumeros"
                  v-model="procedimiento.precioJson.particular"
                  type="float"
                  required
                />
              </div>
            </div>
            <hr />
            <span>Estados (Activos / Inactivos)</span>
            <div class="row mt-1">
              <div class="col">
                <span>Iess</span>
                <b-form-checkbox id="active-iess" v-model="procedimiento.estadoJson.iess" switch />
              </div>
              <div class="col">
                <span>Isspol</span>
                <b-form-checkbox id="active-isspol" v-model="procedimiento.estadoJson.isspol" switch />
              </div>
              <div class="col">
                <span>Issfa</span>
                <b-form-checkbox id="active-issfa" v-model="procedimiento.estadoJson.issfa" switch />
              </div>
              <div class="col">
                <span>Particular</span>
                <b-form-checkbox id="active-particular" v-model="procedimiento.estadoJson.particular" switch />
              </div>
            </div>
            <hr />

            <span>Establecimientos</span>
            <div class="row mt-1 estab-grid">
              <div v-for="est in establecimientosEstado" :key="est.value" class="col-6 mb-2">
                <div class="estab-item">
                  <span class="estab-label">{{ est.text }}</span>
                  <b-form-checkbox v-model="est.activo" switch class="mb-0" />
                </div>
              </div>
            </div>
            <hr />

            <b-form-group label-for="especialidad">
              <label>Especialidad: <span class="text-danger">*</span></label>
              <validation-provider #default="{ errors }" name="especialidad" rules="required">
                <v-select
                  id="especialidad"
                  v-model="procedimiento.especialidad"
                  placeholder="Buscar por especialidad."
                  :options="especialidades"
                  :reduce="option => option.value"
                  label="text"
                  class="d-inline-block w-100"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-button type="submit" class="float-right mt-2" variant="primary">Guardar</b-button>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { comprobarPermisos } from '@/shared/helpers';
import vSelect from 'vue-select';
import actions from '../../assets/utils/utils';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { BContainer, BRow, BCol, BCard, BForm, BFormGroup, BFormInput, BButton, BFormCheckbox, BFormTextarea } from 'bootstrap-vue';

export default {
  name: 'EditarprocedimientoV2',
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    tokenSeleccionado: {
      default: null,
      required: false,
    },
  },
  data() {
    return {
      tituloEditar: null,
      especialidades: [],
      establecimientos: [],
      establecimientosEstado: [],
      procedimiento: {
        id: '',
        token: '',
        descripcion: '',
        codigo: '',
        precio: 0,
        especialidad: '',
        establecimiento: '',
        estado: 1,
        precioJson: {
          issfa_n1: 0,
          issfa_n2: 0,
          iess_n1: 0,
          particular: 0,
          isspol_n1: 0,
        },
        estadoJson: {
          iess: false,
          isspol: false,
          issfa: false,
          particular: false,
        },
      },
    };
  },
  created() {
    this.fetchEspecialidades();
    this.fetchEstablecimientos();
    comprobarPermisos(this.$route);
    this.initDesdeRuta();
  },
  watch: {
    tokenSeleccionado: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.cargarProcedimiento(newValue);
        } else if (!this.getRouteToken()) {
          this.tituloEditar = null;
          actions.setearTitulo('Crear Procedimiento Clinico');
        }
      },
    },
    '$route.params.token': {
      immediate: true,
      handler(newToken) {
        if (newToken) {
          this.cargarProcedimiento(newToken);
        }
      },
    },
    establecimientos() {
      this.syncEstablecimientosEstado();
    },
  },
  methods: {
    initDesdeRuta() {
      const token = this.getRouteToken();
      if (token) this.cargarProcedimiento(token);
    },
    getRouteToken() {
      return this.$route?.params?.token || this.$route?.query?.token || null;
    },
    cargarProcedimiento(token) {
      if (!token || token === this.procedimiento.token) return;
      this.procedimiento.token = token;
      this.tituloEditar = 'Editar Procedimiento';
      this.fetchProcedimiento(token);
    },
    getBaseEstados() {
      return {
        iess: false,
        isspol: false,
        issfa: false,
        particular: false,
      };
    },
    parseFlexibleJson(value, fallback = {}) {
      if (!value) return fallback;
      if (typeof value === 'object') return value;
      try {
        return JSON.parse(value);
      } catch (e) {
        try {
          const fixed = value.replace(/'/g, '"').replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
          return JSON.parse(fixed);
        } catch (err) {
          console.warn('No se pudo parsear JSON flexible', value);
          return fallback;
        }
      }
    },
    normalizeEstados(estadoObj) {
      const base = this.getBaseEstados();
      return Object.keys(base).reduce((acc, key) => {
        const val = estadoObj ? estadoObj[key] : null;
        acc[key] = val === true || val === 1 || val === '1' || val === 'true';
        return acc;
      }, { ...base });
    },
    soloNumeros(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      const isNumberOrDot = /^[0-9.]$/.test(char);
      if (!isNumberOrDot) {
        event.preventDefault();
      }
      const input = event.target;
      if (char === '.' && input.value.includes('.')) {
        event.preventDefault();
      }
    },
    salir() {
      this.$router.push({ name: 'consultar_cartera_procesoclinico' });
    },
    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
          value: item.id,
          text: item.Descripcion,
          uniCodigo: item.uniCodigo,
        }));
        this.syncEstablecimientosEstado();
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },
    async fetchEspecialidades() {
      const query = `
        query {
          allEspecialidad {
            id
            descripcion
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.especialidades = response.data.data.allEspecialidad.map(item => ({
          value: item.id,
          text: item.descripcion,
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },
    async submitForm() {
      const query = `
        mutation actualizarProcedimiento($procedimientoDatos: ProcInputUpdate!) {
          actualizarProcedimiento(procedimientoDatos: $procedimientoDatos) {
            procediminetoActualizado {
              token
              codigo
              descripcion
              establecimiento
              especialidad {
                id
                descripcion
              }
              precio
              estado
              precioJson
              estadoJson
            }
            status
            message
          }
        }
      `;

      const user = JSON.parse(localStorage.getItem('detalleusuario'));
      const idEstablecimiento = user.establecimiento ? user.establecimiento.id : '';

      const variables = {
        procedimientoDatos: {
          token: this.procedimiento.token,
          datos: {
            codigo: this.procedimiento.codigo,
            precioJson: JSON.stringify(this.procedimiento.precioJson),
            estadoJson: JSON.stringify(this.procedimiento.estadoJson),
            descripcion: this.procedimiento.descripcion,
            establecimiento:
              this.establecimientosEstado
                .filter(e => e.activo)
                .map(e => e.value)
                .join(',') || idEstablecimiento,
            especialidad: this.procedimiento.especialidad?.value
              ? this.procedimiento.especialidad.value
              : this.procedimiento.especialidad,
          },
        },
      };

      try {
        const response = await axios.post(rutas.axios + 'api', {
          query,
          variables,
        });

        if (response.data.data.actualizarProcedimiento.status === 'success') {
          await this.$swal({
            icon: 'success',
            title: 'Éxito',
            text: 'La Procedimiento se actualizó correctamente.',
          });
          this.$router.push({ name: 'consultar_cartera_procesoclinico' });
        } else {
          throw new Error(response.data.data.actualizarprocedimiento.message);
        }
      } catch (error) {
        await this.$swal({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Hubo un problema al actualizar la procedimiento.',
        });
      }
    },
    async fetchProcedimiento(token) {
      if (!token) return;
      const query = `
        query GetProcedimiento($tokenproc: String!) {
          allProcs(tokenproc: $tokenproc) {
            total
            status
            message
            procedimiento{
              id
              token
              descripcion
              establecimiento
              especialidad {
                id
                descripcion
              }
              codigo
              estado
              precio
              precioJson
              estadoJson
            }
          }
        }
      `;

      const variables = { tokenproc: token };

      try {
        const response = await axios.post(rutas.axios + 'api', {
          query,
          variables,
        });
        const dataAll = response?.data?.data?.allProcs;
        const proc = dataAll?.procedimiento?.[0];
        if (!proc) {
          console.error('No se encontró procedimiento para token', token, dataAll);
          return;
        }

        const precioParsed = this.parseFlexibleJson(proc.precioJson, this.procedimiento.precioJson);
        const estadoParsed = this.parseFlexibleJson(proc.estadoJson, this.getBaseEstados());
        const precioJson = { ...this.procedimiento.precioJson, ...precioParsed };
        const estadoJson = this.normalizeEstados({ ...this.getBaseEstados(), ...estadoParsed });
        const establecimientoIds = Array.isArray(proc.establecimiento)
          ? proc.establecimiento.map(e => e.id || e).join(',')
          : (proc.establecimiento || '').toString();
        const especialidadData = proc.especialidad ? proc.especialidad.id : this.procedimiento.especialidad;

      this.procedimiento = {
        token: proc.token,
        descripcion: proc.descripcion || '',
        codigo: proc.codigo || '',
        precio: proc.precio || 0,
        especialidad: especialidadData,
        establecimiento: establecimientoIds || '',
        estado: proc.estado,
        precioJson,
        estadoJson,
      };
        this.syncEstablecimientosEstado();
        this.tituloEditar = 'Editar Procedimiento';
      } catch (error) {
        console.error('Error al realizar la consulta GraphQL:', error);
      }
    },
    syncEstablecimientosEstado() {
      const ids = (this.procedimiento.establecimiento || '')
        .toString()
        .split(',')
        .map(i => i.trim())
        .filter(Boolean);
      this.establecimientosEstado = (this.establecimientos || []).map(est => ({
        ...est,
        activo: ids.includes(String(est.value)),
      }));
    },
  },
};
</script>

<style>
.estab-grid .col-6 {
  padding-left: 8px;
  padding-right: 8px;
}

.estab-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: #f9fbff;
  min-height: 38px;
}

.estab-label {
  font-weight: 600;
  font-size: 0.9rem;
  color: #344050;
}
</style>
